// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kT0X","input":"styles_input__nKTAR"};